import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Navigation, Scrollbar, A11y, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';




function BannerOne() {
    return (
        <div>
            {/* banner blank space area */}
            <div className="rts-banner-area rts-banner-one" id='banner'>
                <div className="swiper mySwiper banner-one">

                    <Swiper
                        // install Swiper modules
                        modules={[Navigation, EffectFade, Scrollbar, A11y, Autoplay]}
                        className="rts-brand__slider"
                        speed={700}
                        slidesPerView={1}
                        spaceBetween={0}
                        loop={true}
                        autoplay={{
                            delay: 3000,
                        }}
                        effect='fade'
                        breakpoints={{
                            1200: { slidesPerView: 1 },
                            900: { slidesPerView: 1 },
                            768: { slidesPerView: 1 },
                            580: { slidesPerView: 1 },
                            450: { slidesPerView: 1 },
                            0: { slidesPerView: 1 },
                        }}
                    >
                        <SwiperSlide>
                            {/* banner single content */}
                            <div className="banner-one-inner text-center">
                                <p className="pre-title">
                                    <span>Bienvenue!</span> GLOBAL-SERVICES CONGO Sarlu
                                </p>
                                <h1 className="title ">
                                    Des <span>Services de Qualité</span> <br />
                                    Pour Votre Réussite
                                </h1>
                                <p className="disc banner-para">
                                    Société de prestations de services professionnels
                                </p>
                                <a href="#" className="rts-btn btn-primary color-h-black">
                                    Nos Services
                                </a>
                                <img
                                    className="shape-img one"
                                    src="assets/images/banner/shape/01.png"
                                    alt="banner_business"
                                />
                            </div>
                            {/* banner single content end */}
                        </SwiperSlide>
                        <SwiperSlide>
                            {/* banner single content */}
                            <div className="banner-one-inner text-center">
                                <p className="pre-title">
                                    <span>Expertise!</span> Personnel Expérimenté
                                </p>
                                <h1 className="title ">
                                    Notre <span>Savoir-Faire</span> <br /> À Votre Service
                                </h1>
                                <p className="disc banner-para">
                                    Valeurs, éthique et compétences au service de vos projets
                                </p>
                                <a href="#" className="rts-btn btn-primary color-h-black">
                                    En Savoir Plus
                                </a>
                                <img
                                    className="shape-img one"
                                    src="assets/images/banner/shape/01.png"
                                    alt="banner_business"
                                />
                            </div>
                            {/* banner single content end */}
                        </SwiperSlide>
                        <SwiperSlide>
                            {/* banner single content */}
                            <div className="banner-one-inner text-center">
                                <p className="pre-title">
                                    <span>Accompagnement!</span> Services Personnalisés
                                </p>
                                <h1 className="title ">
                                    Des <span>Solutions Sur Mesure</span> <br /> Pour Votre Projet
                                </h1>
                                <p className="disc banner-para">
                                    Accompagnement personnalisé pour tous vos projets
                                </p>
                                <a href="#" className="rts-btn btn-primary color-h-black">
                                    Contactez-Nous
                                </a>
                                <img
                                    className="shape-img one"
                                    src="assets/images/banner/shape/01.png"
                                    alt="banner_business"
                                />
                            </div>
                            {/* banner single content end */}
                        </SwiperSlide>
                    </Swiper>
                </div>
                <div className="animation-img">
                    <img
                        className="shape-img two"
                        src="assets/images/banner/shape/02.png"
                        alt="banner_business"
                    />
                    <img
                        className="shape-img three"
                        src="assets/images/banner/shape/03.png"
                        alt="banner_business"
                    />
                </div>
            </div>
            {/* banner blank space area end */}
        </div>
    )
}

export default BannerOne